import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faEdit, faHashtag, faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';
import { currencyFormat } from '../../js/Functions';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        suppliersInvoices: [],
        suppliers: [],
        errors: []
    }
    changeValue = (e) => {
        const state = this.state.suppliersInvoices;
        state[e.target.name] = e.target.value;
        this.setState({ suppliersInvoices: state, errors: [] });
    };
    errorVerify(elemento) {
        return this.state.errors.indexOf(elemento) !== -1;
    }
    sendData = async (e) => {
        e.preventDefault();
        const invoice_id = document.getElementById('invoice_id').value;
        const invoice_date = document.getElementById('invoice_date').value;
        const invoice_total = document.getElementById('invoice_total').value;
        const invoice_status = document.getElementById('invoice_status').value;
        const details = document.getElementById('details').value;
        var errors = [];
        if (!invoice_id) { errors.push("error_invoice_id"); }
        if (!invoice_date) { errors.push("error_invoice_date"); }
        if (!invoice_total) { errors.push("error_invoice_total"); }
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        let form = document.getElementById('form_invoice');
        let formData = new FormData(form);
        try {
            Swal.fire({
                title: 'Updating...',
                text: 'Please, wait',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const suppliersInvoicesDataRes = await authAxios.post("suppliers_invoices/update", formData)
            if (!suppliersInvoicesDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            const { ID_INVOICE } = suppliersInvoicesDataRes.data;
            const dataAccountsPayable = {
                invoice_id: invoice_id,
                invoice_date: invoice_date,
                invoice_total: invoice_total,
                invoice_status: invoice_status,
                details: details,
                supplier_id: document.getElementById('supplier_id').value,
                user_id: window.localStorage.getItem('idusuario'),
                id_invoice: ID_INVOICE
            }
            const accountsPayableRes = await authAxios.post("accounts_payable/update", dataAccountsPayable);
            if (!accountsPayableRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Suppliers Invoices!',
                suppliersInvoicesDataRes.data.msj,
                'success'
            );
            this.props.history.push("/UpSuppliersInvoices/" + ID_INVOICE);
            const updatedData = await authAxios.get("suppliers_invoices/view/" + ID_INVOICE)
            this.setState({
                suppliersInvoices: updatedData.data.supplier_invoice,
                suppliers: updatedData.data.supplier,
                load: ''
            });
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("suppliers_invoices/view/" + this.props.match.params.id)
            .then((dataResult) => {
                Swal.showLoading();
                console.log(dataResult);
                this.setState({
                    suppliersInvoices: dataResult.data.supplier_invoice,
                    suppliers: dataResult.data.supplier,
                    load: ''
                });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, suppliersInvoices, suppliers } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {
                                    load ?
                                        (<b>{load}</b>)
                                    :
                                        (<b>UPDATE SUPPLIER INVOICE</b>)
                                }
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData} id="form_invoice">
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INVOICE INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id_invoice" value={this.props.match.params.id} />
                                                    <input type="hidden" name="user_id" id="user_id" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="invoice_id">Invoice ID.</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="invoice_id" id="invoice_id" defaultValue={suppliersInvoices.INVOICE}
                                                            className="form-control form-control-sm" placeholder="Invoice ID." aria-describedby="helpId"
                                                            onChange={this.changeValue} />
                                                    </div>
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_total">Total</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" min="1" name="invoice_total" id="invoice_total" defaultValue={suppliersInvoices.INVOICE_TOTAL}
                                                            className="form-control form-control-sm" placeholder="Invoice Total" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="invoice_date">Invoice Date</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="invoice_date" id="invoice_date" defaultValue={suppliersInvoices.INVOICE_DATE}
                                                            className="form-control form-control-sm" placeholder="Invoice Date" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="invoice_status">Paid Type</label>
                                                    <select name="STATUS"
                                                        id="invoice_status"
                                                        value={suppliersInvoices.STATUS}
                                                        options={suppliersInvoices.STATUS}
                                                        className={((this.errorVerify("error_invoice_status")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.changeValue}>
                                                        <option value="">SELECT PAID TYPE...</option>
                                                        <option value="1">IN PROCESS</option>
                                                        <option value="3">TOTAL PAID</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Please choose Invoice Status</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="details">Other Comments</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} id="details" name="details" rows='3' defaultValue={suppliersInvoices.DETAILS}
                                                        className='form-control form-control-sm' onChange={this.changeValue} aria-describedby="helpId"></textarea>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>SUPPLIER INFORMATION</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-2'>
                                                    <label htmlFor="supplier_id">Supplier ID.</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="supplier_id" id="supplier_id" defaultValue={suppliers.ID_SUPPLIER} 
                                                        className="form-control form-control-sm" placeholder="Supplier ID." aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="supplier_name">Supplier Name</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="supplier_name" id="supplier_name" defaultValue={suppliers.NAME} 
                                                        className="form-control form-control-sm" placeholder="Supplier Name" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="supplier_address">Supplier Address</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="supplier_address" id="supplier_address" defaultValue={suppliers.ADDRESS} 
                                                        className="form-control form-control-sm" placeholder="Supplier Address" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="supplier_phone">Supplier Phone</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="supplier_phone" id="supplier_phone" defaultValue={suppliers.PHONE} 
                                                            className="form-control form-control-sm" placeholder="Supplier Phone" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Please enter Supplier Phone</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Update Invoice</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterSuppliersInvoices"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancel</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;